export const costFormattedUSD = (cost?: number): string => {
    if (typeof cost !== 'number') {
        return '';
    }

    return `$${cost.toFixed(2)} USD`;
};
